<template>
  <div class="card">
    <div class="background">
      <div class="layout-tile">
        <p class="layout-title">核心功能:快速启动程序/打开文件夹/游览网页</p>
      </div>
      <div class="layout-tile">
        <img
          class="layout-img"
          src="@/assets/0_1.gif"
          alt="拖入程序、文件夹或网页链接以创建快速启动入口的演示"
        />
        <div class="layout-contents">
          <p class="layout-desc">只需要将想快速打开的程序/文件夹/网页链接拖入即可</p>
          <p class="layout-desc">也可以点击+号创建图标后再右键设置中修改</p>
        </div>
      </div>
      <div class="layout-tile">
        <div class="layout-contents">
          <p class="layout-desc">创建好图标后直接点击以使用</p>
          <p class="layout-desc">鼠标移上去能看到图标对应的地址</p>
        </div>
        <img
          class="layout-img"
          src="@/assets/0_2.png"
          alt="点击图标快速启动,悬停查看对应地址的示意图"
        />
      </div>
      <div class="layout-tile">
        <img
          class="layout-img"
          src="@/assets/0_3.gif"
          alt="一键隐藏与呼出工具栏,以及配置独立快捷键的演示"
        />
        <div class="layout-contents">
          <p class="layout-desc">一键隐藏/呼出,不占桌面</p>
          <p class="layout-desc">丰富的设置,满足你的需求</p>
          <p class="layout-desc">支持每个入口配置独立快捷键,快速打开你的入口</p>
        </div>
      </div>
    </div>
  </div>
</template>
